import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as matchReducer, REDUCER_NAME as MATCH_REDUCER_NAME } from './match'

const reducer = combineReducers({
    [MATCH_REDUCER_NAME]: matchReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/threeshape/state/index.js